var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarretRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7868 37.8787C17.3963 37.4882 17.3963 36.855 17.7868 36.4645L33.4523 20.799C33.8428 20.4085 33.8428 19.7753 33.4523 19.3848L17.7868 3.7193C17.3963 3.32878 17.3963 2.69561 17.7868 2.30509L19.201 0.890874C19.5915 0.50035 20.2247 0.50035 20.6152 0.890874L37.6949 17.9706C38.8665 19.1421 38.8665 21.0416 37.6949 22.2132L20.6152 39.2929C20.2247 39.6834 19.5915 39.6834 19.201 39.2929L17.7868 37.8787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarretRight);
export default __webpack_public_path__ + "static/media/icon_carret-Right.01e284b9578f6e24e2ec7d45d63e3126.svg";
export { ForwardRef as ReactComponent };